import { useMotionValue, useTransform } from "motion/react";
import type { PanInfo } from "motion/react";

export type SwipeDirection = "left" | "right" | "up" | "down";

export function useCardRotation(
  onThresholdExceed?: (direction: SwipeDirection) => void
) {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-100, 100], [60, -60]);
  const rotateY = useTransform(x, [-100, 100], [-60, 60]);

  const swipeThreshold = 100;

  const handleDragEnd = (_: never, info: PanInfo) => {
    const { offset } = info;
    const absX = Math.abs(offset.x);

    if (absX > swipeThreshold) {
      const direction: SwipeDirection = offset.x >= 0 ? "right" : "left";
      onThresholdExceed?.(direction);
    }

    x.set(0);
    y.set(0);
  };

  return { x, y, rotateX, rotateY, handleDragEnd };
}
